var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"main-section-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h2',[_vm._v(_vm._s(_vm.$t('HEALTH_MONITOR')))])]),_c('health-monitor-filter'),_c('health-monitor-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }